export default {
    manageAttendanceRequest: 'Manage Attendance Request',
    searchByEmployeeName: 'Search by Employee Name',
    employeeNo: 'Employee ID',
    name: 'Name',
    submitted_date: 'Submitted Date',
    group_name: 'Group Name',
    department_name: 'Department',
    request_date: 'Request Date',
    status: 'Status',
    search: 'Search'
}
